import { Helmet } from 'react-helmet-async';
import { defaultOrg } from '../utils/seo';

interface SEOProps {
  title: string;
  description?: string;
  keywords?: string;
  ogImage?: string;
  ogUrl?: string;
  canonical?: string;
  structuredData?: object;
  breadcrumbs?: { name: string; url: string }[];
}

const SITE_URL = 'https://lyrev.vercel.app';

export function SEO({ 
  title, 
  description = ".NET Mastery - Your path to mastering C# and .NET development", 
  keywords = "C#, .NET, coding challenges, programming quiz, developer learning, software development",
  ogImage = `${SITE_URL}/og-image.jpg`,
  ogUrl,
  canonical,
  structuredData,
  breadcrumbs
}: SEOProps) {
  const formattedTitle = `${title} | .NET Mastery`;
  const currentUrl = ogUrl || (typeof window !== 'undefined' ? window.location.href : SITE_URL);
  const canonicalUrl = canonical || currentUrl;

  return (
    <Helmet>
      <title>{formattedTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      
      {/* Canonical URL */}
      <link rel="canonical" href={canonicalUrl} />
      
      {/* Open Graph / Social Media Meta Tags */}
      <meta property="og:title" content={formattedTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:url" content={currentUrl} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content=".NET Mastery" />
      
      {/* Twitter Card Meta Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={formattedTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      <meta name="twitter:site" content="@mohammedkadi" />

      {/* Additional Meta Tags */}
      <meta name="application-name" content=".NET Mastery" />
      <meta name="apple-mobile-web-app-title" content=".NET Mastery" />
      <meta name="theme-color" content="#512BD4" />
      
      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebSite",
          "name": ".NET Mastery",
          "url": SITE_URL,
          "description": description,
          "potentialAction": {
            "@type": "SearchAction",
            "target": `${SITE_URL}/search?q={search_term_string}`,
            "query-input": "required name=search_term_string"
          }
        })}
      </script>
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
} 






